import { render, staticRenderFns } from "./InspectionEventDetails.vue?vue&type=template&id=6f286a8b&"
import script from "./InspectionEventDetails.vue?vue&type=script&lang=js&"
export * from "./InspectionEventDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports